"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _GetApp = _interopRequireDefault(require("@material-ui/icons/GetApp"));

var _solarReact = require("@solar/solar-react");

var _core = require("@material-ui/core");

var _excluded = ["src", "fileName"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var DownloadList = function DownloadList(_ref) {
  var downloads = _ref.downloads,
      setPdfOpen = _ref.setPdfOpen,
      setImageOpen = _ref.setImageOpen,
      _ref$emptyLabel = _ref.emptyLabel,
      emptyLabel = _ref$emptyLabel === void 0 ? 'Je hebt nog geen bestanden gedownload.' : _ref$emptyLabel,
      checkDownload = _ref.checkDownload;

  if (!downloads || downloads.length === 0) {
    return /*#__PURE__*/_react["default"].createElement(_solarReact.EmptyState, {
      Icon: _GetApp["default"],
      label: emptyLabel
    });
  }

  return /*#__PURE__*/_react["default"].createElement(_core.List, null, downloads.map(function (_ref2) {
    var _ref2$document = _ref2.document,
        src = _ref2$document.src,
        fileName = _ref2$document.fileName,
        document = _objectWithoutProperties(_ref2$document, _excluded),
        formattedDate = _ref2.formattedDate,
        certificate = _ref2.certificate;

    return src ? /*#__PURE__*/_react["default"].createElement(_solarReact.FileListItem, {
      interactive: true,
      onClickOpen: function onClickOpen() {
        src.indexOf('.pdf') > 0 ? setPdfOpen(src) : setImageOpen(src);
      },
      label: formattedDate,
      fileUrl: src,
      description: "".concat(fileName),
      onClickDownloadFile: function onClickDownloadFile() {
        src.indexOf('.pdf') > 0 ? checkDownload({
          certificate: certificate,
          doc: _objectSpread({
            src: src,
            fileName: fileName
          }, document),
          unitId: certificate.unitId
        }, function () {
          window.open(src, '__blank');
        }) : window.open(src, '__blank');
      }
    }) : '';
  }));
};

DownloadList.propTypes = {
  downloads: _propTypes["default"].array
};
var _default = DownloadList;
exports["default"] = _default;